"use strict";
/**
 * Copyright © 2019 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATE_HISTOGRAM_CONFIG = exports.DEFAULT_FACET_CONFIG = exports.SUPPORTED_FACET_CONFIG = void 0;
/**
 * We currently support all these tag types
 */
// NOTE: should be in the order of display of the facets
exports.SUPPORTED_FACET_CONFIG = [
    {
        filterKey: 'lotActiveIngredientsOrigEn',
        fieldName: 'lotActiveIngredientOrigEn',
        displayName: 'medicalTechnology',
    },
    {
        filterKey: 'buyerNamesDerived',
        fieldName: 'buyerNameDerived',
        displayName: 'buyerName',
    },
    {
        filterKey: 'contractCpvs',
        fieldName: 'contractCpv',
        displayName: 'Contract CPV',
    },
    {
        filterKey: 'entityIsoCountries',
        fieldName: 'entityIsoCountry',
        displayName: 'location',
    },
    {
        filterKey: 'lotMedicalServiceOrigEn',
        fieldName: 'lotMedicalServiceOrigEn',
        displayName: 'medicalService',
    },
    {
        filterKey: 'contractCpvCodes',
        fieldName: 'contractCpvCode',
        displayName: 'CPV',
    },
    {
        filterKey: 'lotAccessoryConsumableOrigEn',
        fieldName: 'lotAccessoryConsumableOrigEn',
        displayName: 'lotAccessoryConsumables',
    },
    {
        filterKey: 'lotAnatomyOrigEn',
        fieldName: 'lotAnatomyOrigEn',
        displayName: 'lotAnatomy',
    },
    {
        filterKey: 'lotBrandNameOrigEn',
        fieldName: 'lotBrandNameOrigEn',
        displayName: 'lotBrandName',
    },
    {
        filterKey: 'lotCovidTermOrigEn',
        fieldName: 'lotCovidTermOrigEn',
        displayName: 'lotCovidTerm',
    },
    {
        filterKey: 'lotDiseaseOrigEn',
        fieldName: 'lotDiseaseOrigEn',
        displayName: 'lotDisease',
    },
    {
        filterKey: 'lotHealthTechnologyOrigEn',
        fieldName: 'lotHealthTechnologyOrigEn',
        displayName: 'lotHealthTechnology',
    },
    {
        filterKey: 'lotMedicalDeviceOrigEn',
        fieldName: 'lotMedicalDeviceOrigEn',
        displayName: 'lotMedicalDevice',
    },
    {
        filterKey: 'lotMedicalDiagnosisOrigEn',
        fieldName: 'lotMedicalDiagnosisOrigEn',
        displayName: 'lotMedicalDiagnosis',
    },
    {
        filterKey: 'lotNutritionOrigEn',
        fieldName: 'lotNutritionOrigEn',
        displayName: 'lotNutrition',
    },
    {
        filterKey: 'lotProcurementClassificationOrigEn',
        fieldName: 'lotProcurementClassificationOrigEn',
        displayName: 'lotProcurement',
    },
    {
        filterKey: 'lotWorkforceManagementOrigEn',
        fieldName: 'lotWorkforceManagementOrigEn',
        displayName: 'lotWorkforceManagement',
    },
    {
        filterKey: 'lotCovidRecoveryOrigEn',
        fieldName: 'lotCovidRecoveryOrigEn',
        displayName: 'lotCovidRecovery',
    },
    {
        filterKey: 'lotEndEquipmentOrigEn',
        fieldName: 'lotEndEquipmentOrigEn',
        displayName: 'lotEndEquipment',
    },
    {
        filterKey: 'lotFormOrigEn',
        fieldName: 'lotFormOrigEn',
        displayName: 'lotForm',
    },
    {
        filterKey: 'lotMedicalProceduresOrigEn',
        fieldName: 'lotMedicalProceduresOrigEn',
        displayName: 'lotMedicalProcedures',
    },
    {
        filterKey: 'lotPatientManagementOrigEn',
        fieldName: 'lotPatientManagementOrigEn',
        displayName: 'lotPatientManagement',
    },
];
exports.DEFAULT_FACET_CONFIG = [
    {
        filterKey: 'buyerNamesDerived',
        fieldName: 'buyerNameDerived',
        displayName: 'buyerName',
    },
];
exports.DATE_HISTOGRAM_CONFIG = [
    {
        filterKey: 'closeSubmissionDate',
        maxFilterKey: 'maxCloseSubmissionDate',
        fieldName: 'closeSubmissionDate',
        displayName: '',
    },
    {
        filterKey: 'estimatedOpenSubmissionDate',
        maxFilterKey: 'maxEstimatedOpenSubmissionDate',
        fieldName: 'estimatedOpenSubmissionDate',
        displayName: '',
    },
];
//# sourceMappingURL=data:application/json;base64,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